const appConfig = {
    /// app马甲包
    appId: "6",
    /// app名称
    appName: "Hcash",
    /// app包名
    packageName: "com.nigeria.zkkj.hcash",
    /// app版本号
    appVersion: "1.0.3",
    /// app build 号
    appBuild: 102,
    /// app渠道号
    appChannel: "google_3",
}


export default appConfig